

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Component } from '@angular/core';


import{ITransporterMasterModel} from '../../../core/models/masters/transporter-master.model';


//import {RequestPayload,WrapperStandardRequest } from '../../../infrastructure/infrastructure-services/common/models/wrapper.model';
import { GenericListView } from '../../../infrastructure/infrastructure-services/generics/genericlistview/generic-list-view';
import { GenericService } from '../../../infrastructure/infrastructure-services/services/base/generic-service';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { ITransporterMasterModelSAP } from 'src/app/core/models/masters/transporter-master.model';
import { SecurityService } from 'src/app/login-layout/Service/security.service';

@Component({
  selector: 'app-transporter-master-listview',
  templateUrl: './transporter-master-listview.component.html'
})
export class TransporterMasterListviewComponent extends GenericListView<ITransporterMasterModel> {
  auser: any
 
  canAdd: boolean = true;
  canEdit: boolean = true;
  canView: boolean = true;
  isActiveMenu: boolean = true;

  checkMenuPermissions() {
    let securityService = new SecurityService();
    let permissions = securityService.getMenuPermissions(this.getFormTitle);
    this.canAdd = permissions.canAdd;
    this.canEdit = permissions.canEdit;
    this.canView = permissions.canView;
    this.isActiveMenu = permissions.isActive;
  }

  constructor(agenericRepository: GenericService<ITransporterMasterModel>,router: Router) {
    super(agenericRepository,router);

    this.setFormTitle = "Transporter Master";
    this.setFormSubTitle = "This is Sub Title of the Form.";
    this.checkMenuPermissions();
    this.setMenuCode = "";
    this.setEntryFormRouteTo = "/home/sales/transportermasterentryform/"

    this.setListViewDataSourceURL = "EWBTransporters/GetEWBTransportersListService";
    this.setDisplayedColumnsNamesList = ['transporterName','transporterID','action'];
    
    this.getRequestData.SortColumn = "absEntry";

    this.PopulateListView()

  }

}